import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';

const routes: Routes = [

    // {path: 'configuration', redirectTo: '/configuration/products', pathMatch: 'full'},
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    },
    // {
    //   path: 'profile',
    //   loadChildren: './profile/profile.module#ProfileModule'
    // },
    // {
    //   path: 'editor',
    //   loadChildren: './editor/editor.module#EditorModule'
    // },
    // {
    //   path: 'article',
    //   loadChildren: './article/article.module#ArticleModule'
    // }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        // preload all modules; optionally we could
        // implement a custom preloading strategy for just some
        // of the modules (PRs welcome 😉)
        preloadingStrategy: PreloadAllModules
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts